import { required, email, regex } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { mapGetters } from 'vuex';

setInteractionMode("eager")
am4core.useTheme(am4themes_animated);

const reporte = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        loading: false,
        menu: false,
        sedeTitulo: '* Selecciona una sede',
        segmentoTitulo: '* Selecciona un segmento',
        campanaTitulo: '* Selecciona una campana',
        chart: [],
        fecha: '',
        paises: [],
        paisSelected: [],
        centroSelected: [],
        segmentoSelected: [],
        campanaSelected: [],
        sedeChart: [],
        segmentoChart: [],
        campanaChart: [],
    }),
    mounted() {
        this.getYearMonth();
        this.getData();
        this.sedeGraphic();
        this.segmentoGraphic();
        this.campanaGraphic();
    },
    methods: {
        getYearMonth() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Añadir un 0 si el mes es menor a 10
            this.fecha = `${year}-${month}`;
        },
      
        async getData(){
            this.loading = true;
            const response = await this.$axios.post('/reporte/reuniones', {'fecha' : this.fecha, data : this.info});
            this.loading = false;
            this.paisSelected = response.data.pais;
            this.centroSelected = response.data.centro;
            this.segmentoSelected = response.data.segmento;
            this.campanaSelected = response.data.campana;

            this.paises = [];
            this.chart.data = [];
            this.segmentoChart.data = [];
            this.campanaChart.data = [];
            this.sedeTitulo = '* Selecciona una sede';
            this.segmentoTitulo = '* Selecciona un segmento';
            this.campanaTitulo = '* Selecciona una campana';
            
            Object.entries(response.data.pais).forEach(([key, value]) => {
                this.paises.push({
                    "nombre": key,
                    "total": value.length
                });
            });

        },
        filtrarPais(pais){
            this.sedeTitulo = '* Selecciona una sede';
            this.segmentoTitulo = '* Selecciona un segmento';
            this.campanaTitulo = '* Selecciona una campana';
            var rows = [];
            Object.entries(this.centroSelected).forEach(([key, value]) => {
                var selected = value.filter(item => {
                    return item.paisNombre == pais
                })

                if(selected.length > 0){
                    rows.push({
                        "country": key,
                        "visits": selected.length
                    })
                }
            });

            this.chart.data = rows;
            this.segmentoChart.data = [];
            this.campanaChart.data = [];
        },
        filterSede(sede){
            this.sedeTitulo = sede;
            this.segmentoTitulo = '* Selecciona un segmento';
            this.campanaTitulo = '* Selecciona una campana';

            var rows = [];
            Object.entries(this.segmentoSelected).forEach(([key, value]) => {
                var selected = value.filter(item => {
                    return item.centroNombre == sede
                })

                if(selected.length > 0){
                    rows.push({
                        "country": key,
                        "visits": selected.length
                    })
                }
            });

            this.segmentoChart.data = rows;
            this.campanaChart.data = [];
        },
        filterSegmento(segmento){
            this.segmentoTitulo = segmento;
            this.campanaTitulo = '* Selecciona una campana';

            var rows = [];
            Object.entries(this.campanaSelected).forEach(([key, value]) => {
                var selected = value.filter(item => {
                    return item.segmentoNombre == segmento
                })

                if(selected.length > 0){
                    rows.push({
                        "country": key,
                        "visits": selected.length
                    })
                }
            });

            this.campanaChart.data = rows;
        },
        
        sedeGraphic() {
            
            this.chart = am4core.create(this.$refs.sedeGraphic, am4charts.XYChart);
            this.chart.data = this.sedeChart;
            this.chart.padding(40, 40, 40, 40);
            this.chart.logo.height = -1000;

            
            let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "country";
            categoryAxis.renderer.minGridDistance = 50;
            categoryAxis.renderer.inversed = true;
            categoryAxis.renderer.grid.template.disabled = true;
            categoryAxis.renderer.labels.template.rotation = 45;
            categoryAxis.renderer.labels.template.maxWidth = 130;
            categoryAxis.renderer.labels.template.wrap = true;
            categoryAxis.renderer.labels.template.tooltipText = "{categoryX}";

            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.extraMax = 0.1;
            valueAxis.rangeChangeEasing = am4core.ease.linear;
            valueAxis.rangeChangeDuration = 1500;

            let series = this.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "country";
            series.dataFields.valueY = "visits";
            series.tooltipText = "{valueY.value}";
            series.columns.template.strokeOpacity = 0;
            series.columns.template.column.cornerRadiusTopRight = 10;
            series.columns.template.column.cornerRadiusTopLeft = 10;
            series.columns.template.fill = am4core.color("#04ba5a"); 

            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.verticalCenter = "bottom";
            labelBullet.label.dy = -10;
            labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

            series.columns.template.events.on("hit", function (event,) {
                var column = event.target;
                var category = column.dataItem.categoryX;
                var value = column.dataItem.valueY;

                this.filterSede(category);

            }, this);
            

            categoryAxis.sortBySeries = series;


        },
        segmentoGraphic() {
           
            // // Rota las etiquetas del eje X
            // categoryAxis.renderer.labels.template.rotation = 45; 
            // // categoryAxis.renderer.labels.template.horizontalCenter = "center"; 
            // // categoryAxis.renderer.labels.template.verticalCenter = "center"; 

            // categoryAxis.renderer.labels.template.maxWidth = 130;  
            // categoryAxis.renderer.labels.template.wrap = true;      
            // categoryAxis.renderer.labels.template.tooltipText = "{categoryX}";  

            // series.columns.template.events.on("hit", function (event,) {
            //     var column = event.target;
            //     var category = column.dataItem.categoryX;
            //     var value = column.dataItem.valueY;
            // }, this);
            
            this.segmentoChart = am4core.create(this.$refs.segmentoGraphic, am4charts.XYChart);

            this.segmentoChart.data = this.segmentoChart;
            this.segmentoChart.padding(40, 40, 40, 40);
            this.segmentoChart.logo.height = -1000;

            let categoryAxis = this.segmentoChart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "country";
            categoryAxis.renderer.minGridDistance = 50;
            categoryAxis.renderer.inversed = true;
            categoryAxis.renderer.grid.template.disabled = true;
            categoryAxis.renderer.labels.template.rotation = 45;
            categoryAxis.renderer.labels.template.maxWidth = 130;
            categoryAxis.renderer.labels.template.wrap = true;
            categoryAxis.renderer.labels.template.tooltipText = "{categoryX}";

            let valueAxis = this.segmentoChart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.extraMax = 0.1;
            valueAxis.rangeChangeEasing = am4core.ease.linear;
            valueAxis.rangeChangeDuration = 1500;

            let series = this.segmentoChart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "country";
            series.dataFields.valueY = "visits";
            series.tooltipText = "{valueY.value}";
            series.columns.template.strokeOpacity = 0;
            series.columns.template.column.cornerRadiusTopRight = 10;
            series.columns.template.column.cornerRadiusTopLeft = 10;
            series.columns.template.fill = am4core.color("#04ba5a"); 

            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.verticalCenter = "bottom";
            labelBullet.label.dy = -10;
            labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

            series.columns.template.events.on("hit", function (event,) {
                var column = event.target;
                var category = column.dataItem.categoryX;
                var value = column.dataItem.valueY;

                this.filterSegmento(category);
            }, this);
            

            categoryAxis.sortBySeries = series;


        },
        campanaGraphic() {
           
            // // Rota las etiquetas del eje X
            // categoryAxis.renderer.labels.template.rotation = 45; 
            // // categoryAxis.renderer.labels.template.horizontalCenter = "center"; 
            // // categoryAxis.renderer.labels.template.verticalCenter = "center"; 

            // categoryAxis.renderer.labels.template.maxWidth = 130;  
            // categoryAxis.renderer.labels.template.wrap = true;      
            // categoryAxis.renderer.labels.template.tooltipText = "{categoryX}";  

            // series.columns.template.events.on("hit", function (event,) {
            //     var column = event.target;
            //     var category = column.dataItem.categoryX;
            //     var value = column.dataItem.valueY;
            // }, this);
            
            this.campanaChart = am4core.create(this.$refs.campanaGraphic, am4charts.XYChart);

            this.campanaChart.data = this.campanaChart;
            this.campanaChart.padding(40, 40, 40, 40);
            this.campanaChart.logo.height = -1000;

            let categoryAxis = this.campanaChart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "country";
            categoryAxis.renderer.minGridDistance = 50;
            categoryAxis.renderer.inversed = true;
            categoryAxis.renderer.grid.template.disabled = true;
            categoryAxis.renderer.labels.template.rotation = 45;
            categoryAxis.renderer.labels.template.maxWidth = 130;
            categoryAxis.renderer.labels.template.wrap = true;
            categoryAxis.renderer.labels.template.tooltipText = "{categoryX}";

            let valueAxis = this.campanaChart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.extraMax = 0.1;
            valueAxis.rangeChangeEasing = am4core.ease.linear;
            valueAxis.rangeChangeDuration = 1500;

            let series = this.campanaChart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "country";
            series.dataFields.valueY = "visits";
            series.tooltipText = "{valueY.value}";
            series.columns.template.strokeOpacity = 0;
            series.columns.template.column.cornerRadiusTopRight = 10;
            series.columns.template.column.cornerRadiusTopLeft = 10;
            series.columns.template.fill = am4core.color("#04ba5a"); 

            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.verticalCenter = "bottom";
            labelBullet.label.dy = -10;
            labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

            series.columns.template.events.on("hit", function (event) {
            var column = event.target;
            var category = column.dataItem.categoryX;
            var value = column.dataItem.valueY;
            });

            series.columns.template.events.on("hit", function (event,) {
                var column = event.target;
                var category = column.dataItem.categoryX;
                var value = column.dataItem.valueY;

            }, this);
            

            categoryAxis.sortBySeries = series;


        },
    },
}


export default reporte;